





































import {
  defineComponent,
  ref,
  computed,
  onMounted,
} from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'SliderWithButtons',
  setup(_, { slots }) {
    const agileRef = ref<any>(null)
    const isMounted = ref(false)
    onMounted(() => {
      isMounted.value = true
    })

    const agileOptions = {
      navButtons: false,
      dots: true,
      infinite: false,
      speed: 800,
      slidesToShow: 1,
    }

    const slidesCount = computed(() => {
      return slots.default?.().length || 0
    })

    const DOT_SIZE = 8
    const DOT_GAP = 8
    const ARROW_OFFSET = 20

    const dotsWidth = computed(() => {
      if (slidesCount.value <= 1) return DOT_SIZE
      return slidesCount.value * DOT_SIZE + (slidesCount.value - 1) * DOT_GAP
    })

    const prevStyle = computed(() => ({
      marginRight: `${ARROW_OFFSET}px`,
    }))

    const nextStyle = computed(() => ({
      marginLeft: `${ARROW_OFFSET}px`,
    }))

    const prev = () => {
      if (canPrev.value) agileRef.value.goToPrev()
    }

    const next = () => {
      if (canNext.value) agileRef.value.goToNext()
    }

    const canPrev = computed(() => agileRef.value?.canGoToPrev ?? false)
    const canNext = computed(() => agileRef.value?.canGoToNext ?? false)

    return {
      agileRef,
      agileOptions,
      prev,
      next,
      isMounted,
      canPrev,
      canNext,
      nextStyle,
      prevStyle,
      dotsWidth,
    }
  },
})
